import { render } from "./TodoCard.vue?vue&type=template&id=bcb3fd4c"
import script from "./TodoCard.vue?vue&type=script&lang=js"
export * from "./TodoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__